var _style, _path, _g, _path2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRunwayUkLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 150",
    style: {
      enableBackground: "new 0 0 171 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{opacity:0.5;}\r\n\t.st2{fill:url(#SVGID_00000136399120031356411830000010862770346084506036_);}\r\n\t.st3{fill:#EF091F;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#001F80;}\r\n\t.st6{fill:#FF4651;}\r\n\t.st7{fill:url(#SVGID_00000036227662674043821550000006428549799921346464_);}\r\n\t.st8{fill:url(#SVGID_00000078019547322323207420000007400180802051831428_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.787,
    y1: -499.1933,
    x2: 92.5914,
    y2: -479.4573,
    gradientTransform: "matrix(1 0 0 -1 0 -384)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EF091F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3206,
    style: {
      stopColor: "#AA0017"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3865,
    style: {
      stopColor: "#970323"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6848,
    style: {
      stopColor: "#461255"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8963,
    style: {
      stopColor: "#141B74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001F80"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.92,131.55l59.1,24.57L25.05,45.67L25,156.26L55.92,131.55z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029029271065911446060000007957823251334283657_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.5967,
    y1: -479.391,
    x2: 10.8284,
    y2: -499.1081,
    gradientTransform: "matrix(1 0 0 -1 0 -384)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4BDBFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#FFE2D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D770FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029029271065911446060000007957823251334283657_)"
    },
    d: "M25.94,48.19l86.1,105.68L56.28,130.7 l-0.5-0.23l-0.41,0.32L25.9,154.28V48.19 M25.04,45.63v110.59l30.88-24.71l59.1,24.53L25.04,45.67V45.63z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M118.63,76.46v1.04c0.05,2.25-0.18,4.46-0.63,6.66H70.65v6.75L54.13,70.65h1.13V43.74h15.39v26.92h47.44 C118.45,72.54,118.63,74.48,118.63,76.46z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "55.25,43.74 55.25,70.65 54.13,70.65 45.94,60.62 50.17,62.82 50.17,43.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "50.17,43.74 50.17,62.82 45.94,60.62 45.94,60.57 32.21,43.74  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M116.74,88.7h-17.6l13.95,7.34c-0.41,0.59-0.86,1.17-1.35,1.76l-17.42-9.14H84.06l24.39,12.74 c-1.89,1.85-3.96,3.38-6.21,4.64L75.82,92.08v5.18l-5.18-6.35v-6.75H118C117.73,85.69,117.32,87.22,116.74,88.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M102.24,106.03c-1.08,0.63-2.25,1.17-3.42,1.67c-3.92,1.67-8.15,2.52-12.42,2.52L75.82,97.25v-5.18 L102.24,106.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M111.74,97.79c-0.72,0.99-1.53,1.89-2.39,2.79c-0.27,0.32-0.59,0.59-0.9,0.81L84.06,88.66h10.26L111.74,97.79z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M116.74,88.7c-0.14,0.41-0.27,0.86-0.45,1.26c-0.86,2.16-1.94,4.19-3.2,6.08L99.14,88.7H116.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M118.09,70.65H70.65V43.74h5.18v19.08l27.05-14.31c0.81,0.5,1.58,0.99,2.3,1.58l-29.3,15.26v0.77h8.78 l24.3-12.87c0.04,0.05,0.04,0.05,0.09,0.09c1.67,1.67,3.11,3.47,4.32,5.4L99.14,66.2h17.78C117.46,67.64,117.82,69.12,118.09,70.65 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M102.87,48.51L75.82,62.82V43.74h10.08C91.94,43.74,97.83,45.4,102.87,48.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M108.95,53.24l-24.3,12.87h-8.78v-0.77l29.3-15.26C106.52,50.99,107.78,52.07,108.95,53.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M116.92,66.2H99.14l14.22-7.47C114.89,61.07,116.11,63.54,116.92,66.2z"
  }))), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M192.7-196.83c2.98-3.88,4.55-8.66,4.46-13.55c0.11-2.32-0.4-4.64-1.47-6.7c-1.08-2.06-2.68-3.81-4.65-5.05 c-5.03-2.95-10.83-4.36-16.65-4.05c-2.7,0-8.37,0.23-17.01,0.68l-11.88,65.08h11.88l0.14-0.86l4.86-26.42 c2.93,0.23,5.4,0.32,7.43,0.36l12.42,26.92h13.01l-14.54-28.81c4.74-1.02,8.96-3.68,11.93-7.52L192.7-196.83z M168.85-197.05 c-1.56-0.01-3.13-0.1-4.68-0.27l3.33-18.23c2.39-0.32,3.83-0.45,4.23-0.45c3.66-0.27,7.32,0.38,10.67,1.89 c1.08,0.66,1.96,1.6,2.53,2.73c0.57,1.13,0.82,2.4,0.71,3.66C185.64-200.61,180.04-197.05,168.85-197.05z M238.93-208.03h11.16 l-8.87,47.62h-11.12l0.68-3.47c-4.39,3.01-9.63,4.52-14.94,4.32c-1.77,0.16-3.56-0.08-5.22-0.69c-1.67-0.61-3.18-1.58-4.43-2.85 c-1.25-1.26-2.21-2.79-2.8-4.46c-0.59-1.68-0.81-3.46-0.64-5.23c0.03-1.54,0.2-3.08,0.5-4.59l5.72-30.65h11.3l-5.63,30.2 c-0.21,1.07-0.33,2.15-0.36,3.24c0,3.87,2.16,5.76,6.48,5.76c1.63,0.05,3.26-0.23,4.78-0.82c1.52-0.59,2.91-1.47,4.09-2.6 c2.34-2.21,3.9-5.11,4.46-8.28l4.91-27.5H238.93z M298.7-195.21c-0.04,1.93-0.25,3.86-0.63,5.76l-5.36,28.94h-11.52l5.18-27.73 c0.37-1.84,0.58-3.71,0.63-5.58c0-3.92-2.34-5.9-6.98-5.9c-2.04,0.03-4.05,0.5-5.9,1.37c-1.85,0.87-3.49,2.12-4.82,3.67 l-6.35,34.21H251.8l6.71-35.65c0.14-0.85,0.2-1.71,0.18-2.57c-0.04-2.87-0.48-5.72-1.31-8.46l10.89-1.98l1.04,5.31 c4.1-3.47,9.35-5.29,14.72-5.09c9.77,0,14.66,4.58,14.67,13.73V-195.21z M363.38-208.03h11.79l-26.11,48.47h-4.01l-8.33-27.5 l-17.82,27.5h-4.1l-9.36-48.47h11.3l4.77,26.2l16.29-26.2h4.01l7.88,26.51l13.73-26.51H363.38z M421.53-206.68 c-5.61-1.77-11.5-2.52-17.37-2.21c-3.95-0.04-7.85,0.81-11.43,2.49c-3.58,1.68-6.73,4.13-9.23,7.19 c-5.47,6.48-8.38,14.74-8.19,23.22c-0.14,2.2,0.17,4.4,0.89,6.48c0.73,2.08,1.86,3.99,3.34,5.63c1.59,1.51,3.47,2.67,5.53,3.42 c2.06,0.75,4.25,1.07,6.44,0.94c2.62,0.07,5.23-0.39,7.67-1.36c2.44-0.97,4.65-2.42,6.51-4.27c0.99,3.15,2.57,4.77,4.64,4.77h6.93 c-1.26-4.35-1.78-8.89-1.53-13.41c-0.02-1.22,0.09-2.44,0.32-3.65l5.49-29.17V-206.68z M402.76-174.55 c-0.74,1.64-1.91,3.05-3.38,4.09c-1.47,1.04-3.19,1.66-4.99,1.81c-1.04,0.14-2.09,0.03-3.08-0.31c-0.99-0.34-1.89-0.91-2.62-1.65 c-0.73-0.75-1.28-1.65-1.61-2.65c-0.32-1-0.41-2.05-0.25-3.09c-0.11-5.79,1.43-11.49,4.46-16.43c1.15-2.15,2.86-3.95,4.96-5.2 c2.09-1.25,4.49-1.91,6.93-1.91c2.01,0.03,4.01,0.33,5.94,0.9c-0.76,8.44-2.92,16.7-6.39,24.44H402.76z M475-208.03l-25.07,52.35 c-5.54,10.76-16.74,13.86-29.48,13.91l3.78-10.71c8.37,0,13.77-2.75,16.11-8.15l2.3-5.31c-4.05-1.17-6.8-5.4-8.24-12.78 l-5.63-29.26h11.7c3.47,20.84,5.67,31.72,6.62,32.63l15.26-32.63h12.56L475-208.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021816456237235547160000017921090351871278220_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.787,
    y1: -206.1933,
    x2: 92.5914,
    y2: -186.4573,
    gradientTransform: "matrix(1 0 0 -1 0 -384)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EF091F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3206,
    style: {
      stopColor: "#AA0017"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3865,
    style: {
      stopColor: "#970323"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6848,
    style: {
      stopColor: "#461255"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8963,
    style: {
      stopColor: "#141B74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001F80"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021816456237235547160000017921090351871278220_)"
    },
    d: "M55.92-161.45l59.1,24.57L25.05-247.33 L25-136.74L55.92-161.45z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031893434097623340580000009776960723196554424_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.5967,
    y1: -186.391,
    x2: 10.8284,
    y2: -206.1081,
    gradientTransform: "matrix(1 0 0 -1 0 -384)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4BDBFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#FFE2D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D770FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031893434097623340580000009776960723196554424_)"
    },
    d: "M25.94-244.81l86.1,105.68L56.28-162.3 l-0.5-0.23l-0.41,0.32L25.9-138.72v-106.09 M25.04-247.37v110.59l30.88-24.71l59.1,24.53L25.04-247.33V-247.37z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M118.63-216.54v1.04c0.05,2.25-0.18,4.46-0.63,6.66H70.65v6.75l-16.52-20.25h1.13v-26.92h15.39v26.92h47.44 C118.45-220.46,118.63-218.52,118.63-216.54z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "55.25,-249.26 55.25,-222.35 54.13,-222.35 45.94,-232.38 50.17,-230.18 50.17,-249.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "50.17,-249.26 50.17,-230.18 45.94,-232.38 45.94,-232.43 32.21,-249.26  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M116.74-204.3h-17.6l13.95,7.34c-0.41,0.59-0.86,1.17-1.35,1.76l-17.42-9.14H84.06l24.39,12.74 c-1.89,1.85-3.96,3.38-6.21,4.64l-26.42-13.95v5.18l-5.18-6.35v-6.75H118C117.73-207.31,117.32-205.78,116.74-204.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M102.24-186.97c-1.08,0.63-2.25,1.17-3.42,1.67c-3.92,1.67-8.15,2.52-12.42,2.52l-10.58-12.96v-5.18 L102.24-186.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M111.74-195.21c-0.72,0.99-1.53,1.89-2.39,2.79c-0.27,0.32-0.59,0.59-0.9,0.81l-24.39-12.74h10.26 L111.74-195.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M116.74-204.3c-0.14,0.41-0.27,0.86-0.45,1.26c-0.86,2.16-1.94,4.19-3.2,6.08l-13.95-7.34H116.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M118.09-222.35H70.65v-26.92h5.18v19.08l27.05-14.31c0.81,0.5,1.58,0.99,2.3,1.58l-29.3,15.26v0.77h8.78 l24.3-12.87c0.04,0.05,0.04,0.05,0.09,0.09c1.67,1.67,3.11,3.47,4.32,5.4l-14.22,7.47h17.78 C117.46-225.36,117.82-223.88,118.09-222.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M102.87-244.49l-27.05,14.31v-19.08h10.08C91.94-249.26,97.83-247.6,102.87-244.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M108.95-239.76l-24.3,12.87h-8.78v-0.77l29.3-15.26C106.52-242.01,107.78-240.93,108.95-239.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M116.92-226.8H99.14l14.22-7.47C114.89-231.93,116.11-229.46,116.92-226.8z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunwayUkLogo);
export default __webpack_public_path__ + "static/media/RunwayUkLogo.ea983a8f1f244b37c98152300030c699.svg";
export { ForwardRef as ReactComponent };